/**
 * Camada 1 · superficie publica dos componentes.
 *
 * A folha de estilo NAO e reexportada daqui: ela e importada pelo app com
 * `import '@complexity/ui/styles.css'`. CSS que entra por import de modulo JavaScript
 * depende do bundler processar aquele caminho, e o site em Astro nao usa o mesmo.
 */
export { Botao } from './components/Button.js';
export type { BotaoProps, TamanhoBotao, VarianteBotao } from './components/Button.js';

export { Campo } from './components/Input.js';

/*
 * O SELO DE ESTADO, somado em 09/09/2026.
 *
 * Ele nasceu porque a varredura de cor achou o mesmo markup copiado em SETE lugares, cada um
 * com o proprio mapa. Enquanto cada tela escrever o selo a mao, mudanca de token nao alcanca
 * nenhuma delas de forma uniforme.
 */
export { Selo } from './components/Selo.js';
export type { PropsSelo, TomDoSelo } from './components/Selo.js';
export type { CampoProps } from './components/Input.js';

// O CAMPO DE DINHEIRO, somado em 08/09/2026 pelo pedido "VALORES EM INPUT DEVE TER MASCARA
// 99.999,00". Ele NAO e uma prop do `Campo`: quem chama informa CENTAVOS INTEIROS e recebe
// centavos de volta, e a conversao de reais para centavos deixa de existir copiada em cada
// tela. No medico-concierge ela existia TRES vezes, e uma das tres era diferente das outras.
export { CampoMoeda } from './components/CampoMoeda.js';
export { CampoCpf, formatarCpf, digitosDeCpf } from './components/CampoCpf.js';
// A CONFERENCIA do digito verificador, para a tela recusar antes de o servidor recusar.
export { cpfConfere } from './components/cpf.js';
export type { CampoCpfProps } from './components/CampoCpf.js';
export type { CampoMoedaProps } from './components/CampoMoeda.js';

// As funcoes puras da mascara, para quem precisa formatar sem o campo (resumo, recibo, teste).
export { centavosParaTexto, textoParaCentavos, mascararDigitacao } from './moeda.js';

// O TEXTO LONGO, somado em 06/09/2026. Ele NAO e uma variante do `Campo` com uma prop
// `multilinha`: `input` e `textarea` sao elementos diferentes, com atributos diferentes
// (`rows` nao existe num, `type` nao existe no outro), e uma prop que troca o elemento
// faria metade das props do tipo serem invalidas dependendo do valor de outra.
export { CampoTexto } from './components/CampoTexto.js';
export type { CampoTextoProps } from './components/CampoTexto.js';

// Camada 1 · o combobox da plataforma, migrado do prontidaovoo. O que varia por produto e o que
// ele BUSCA, e isso entra por prop: a peca nao conhece dominio nenhum.
export { CampoBusca } from './components/CampoBusca.js';
export type { CampoBuscaProps } from './components/CampoBusca.js';

// Camada 1 · escolha entre opcoes fechadas, com `<select>` nativo: no celular ele abre a roda do
// sistema, que e o gesto que a pessoa ja conhece.
// Camada 1 · markdown em texto, sem biblioteca: tres telas ja precisam dele, e um por produto
// divergiria no primeiro ajuste.
export { Markdown } from './components/Markdown.js';

export { Selecao } from './components/Selecao.js';
export type { SelecaoProps, OpcaoDeSelecao } from './components/Selecao.js';
export { SelecaoMultipla } from './components/SelecaoMultipla.js';
export type { SelecaoMultiplaProps, OpcaoMultipla } from './components/SelecaoMultipla.js';

// Camada 1 · copiar texto para a area de transferencia, com a reserva para contexto nao seguro.
export { BotaoCopiar } from './components/BotaoCopiar.js';
export type { BotaoCopiarProps } from './components/BotaoCopiar.js';

// O DITADO E TRANSVERSAL, e nao do medicina: qualquer campo de texto longo da plataforma
// pode receber fala em vez de digitacao. Ele nasceu em 07/09/2026 e ficou UMA HORA em
// disco sem esta linha, entao existia e nenhum app conseguia importa-lo: peca sem export
// e peca que nao existe, e o typecheck nao acusa porque ninguem a procura.
export { BotaoDitar } from './components/BotaoDitar.js';
export type { BotaoDitarProps } from './components/BotaoDitar.js';

/*
 * O VISUALIZADOR DE PDF, somado em 07/10/2026 pelo pedido do fundador: *"O visualizador do pdf deve
 * ser bem otimizado para todos os dispositivos, utilize uma forma ja consolidada pra isso (no manual
 * ou qualquer lugar que tenha que ver um pdf no sistema)"*.
 *
 * ELE NASCE AQUI, e nao dentro de um app, porque DOIS lugares mostram PDF: a aba "Manual Foto
 * Modelo" da cliente e a sub-aba "Manual Foto" do painel. Escrito num dos dois, o outro copiaria.
 *
 * O CODIGO DO pdf.js NAO ENTRA NO PACOTE DE QUEM SO IMPORTA ESTA LINHA: a peca carrega a biblioteca
 * por `import()` dinamico, medido em 07/10/2026. Com import estatico, o pacote principal ia de
 * 147 kB para 629 kB, e todo app que usa qualquer peca do Chassi pagaria por isso, inclusive a tela
 * de login do admin, que nunca mostra PDF.
 */
export { VisualizadorPdf } from './components/VisualizadorPdf.js';
export type { VisualizadorPdfProps } from './components/VisualizadorPdf.js';

export { Modal } from './components/Modal.js';
export type { ModalProps } from './components/Modal.js';

export { Tabela } from './components/Table.js';
export type { Coluna, TabelaProps } from './components/Table.js';

export { CartaoMetrica, CLASSE_FILEIRA_DE_INDICADORES } from './components/MetricCard.js';
export type { CartaoMetricaProps } from './components/MetricCard.js';

export { GraficoBarras } from './components/BarChart.js';
export type { BarraDado, GraficoBarrasProps } from './components/BarChart.js';

export { ListaVencimento } from './components/DueList.js';
export type { FaixaVencimento, ItemVencimento, ListaVencimentoProps } from './components/DueList.js';

export { MolduraCentral } from './components/Frame.js';
export type { MolduraCentralProps } from './components/Frame.js';

export { EstadoErro, EstadoSessaoExpirada, EstadoVazio } from './components/EmptyState.js';
export type {
  EstadoErroProps,
  EstadoSessaoExpiradaProps,
  EstadoVazioProps,
} from './components/EmptyState.js';

/**
 * O conjunto de icones, portado do legado `prontidaovoo` em 29/08/2026 (linha V03 da
 * paridade). O `ICONES` e o mapa que liga o nome escrito no ProductConfig ao desenho, e e
 * ele que permite um produto NOMEAR um icone em vez de desenhar o proprio.
 */
export {
  ICONES,
  icone,
  IconeAjustes,
  IconeAuditoria,
  IconeBusca,
  IconeBussola,
  IconeCadeado,
  IconeChevron,
  // Os 13 do `medico-concierge`, desenhados em 06/09/2026. Eles ja estavam no
  // mapa ICONES e faltavam AQUI, e a diferenca nao e cosmetica: o mapa resolve
  // o nome que vem do manifesto, e o barrel e o unico caminho para uma tela
  // importar o desenho por nome. Sem estas linhas, `import { IconeAgenda }`
  // nao compila, e o `exports` do pacote bloqueia o import profundo.
  IconeAgenda,
  IconeRecepcao,
  IconeAtendimento,
  IconeMicrofone,
  IconePrescricao,
  IconeAssinatura,
  IconeReembolso,
  IconeFinanceiro,
  IconeConcierge,
  IconeConversa,
  IconeRelogio,
  IconeProntuario,
  IconePagamento,
  IconeConformidade,
  IconeDespublicar,
  IconeDiario,
  IconeEmpresas,
  IconeFechar,
  IconeFrota,
  IconeIa,
  IconeIdioma,
  IconeInventario,
  IconeLua,
  IconeLapis,
  IconeLixeira,
  IconeMapa,
  IconeMenu,
  IconeMeteorologia,
  IconeNormas,
  IconeNotam,
  IconePainel,
  IconePainelLateral,
  IconePessoas,
  IconePublicar,
  IconePrivacidade,
  IconeRegistros,
  IconeSair,
  IconeSeguranca,
  IconeSino,
  IconeAjuda,
  IconeSobre,
  IconeSol,
  IconeTripulacao,
  IconeUsuarios,
  IconeVer,
  IconeVoar,
  IconeVoltar,
  IconeVoos,
} from './components/Icones.js';
export type { NomeIcone } from './components/Icones.js';

// Marcas de terceiro. Ficam em pasta propria porque sao o UNICO lugar da plataforma onde
// cor literal e legitima: a identidade e de outro, e trocar por token nosso descaracteriza
// o simbolo. Ver o override em packages/config/eslint.config.js.
export { LogoGoogle } from './components/marcas/LogoGoogle.js';
export type { LogoGoogleProps } from './components/marcas/LogoGoogle.js';

// AS DUAS PECAS QUE VIERAM DE @complexity/layout em 31/08/2026, por decisao dele em enquete.
//
// O ADR 0029 e explicito: Peca mora em @complexity/ui. Elas nasceram em `layout` (camada 1b)
// por acidente, e MEDIDO: nao precisavam de nada de la. `FaixaAmbiente` importa so `i18n`, e
// `ControlesIdiomaTema` importa `i18n`, `theme` e o proprio `ui`. Camada 0 e 1a.
//
// O CUSTO DE ELAS FICAREM LA era concreto: `packages/auth` (1b) precisa das duas na tela de
// login e importava de `layout` (1b). Era a UNICA violacao de camada do repositorio, e ficou
// escondida enquanto o `graph:check` esteve inerte, entre 30 e 31/08/2026.
export { FaixaAmbiente } from './components/FaixaAmbiente.js';
export type { FaixaAmbienteProps } from './components/FaixaAmbiente.js';
export { ControlesIdiomaTema } from './components/ControlesIdiomaTema.js';
export { BotaoIcone, AcoesDaLinha } from './components/BotaoIcone.js';

// Camada 1 · as duas superficies que toda tela repete. Medido em 06/09/2026: o markup do
// cartao aparecia 24 vezes a mao nos apps, e o do aviso 11. Sao 35 copias de duas decisoes,
// e nenhuma das 11 de aviso declarava `role`: o aviso existia para quem ve e nao existia
// para quem ouve. ADR 0052.
export { Cartao, Aviso } from './components/Superficie.js';
export type { CartaoProps, AvisoProps, TomDeAviso } from './components/Superficie.js';

// A REDUCAO DE IMAGEM mora aqui, em camada 0, porque ela serve DOIS lados que nao se
// importam entre si: o formulario da Ajuda (packages/help) e a resposta do Super Admin
// (apps/admin). Colocada num dos dois, o outro teria que importar do vizinho ou duplicar,
// e duplicar e o que faz a mesma regra envelhecer de um lado so.
//
// ELA NAO E UM COMPONENTE, e por isso nao esta em components/: e uma funcao pura de
// navegador, sem tela, e misturada com os componentes ela seria dificil de achar.
export { reduzirImagemParaAnexo, TETO_ANEXO_BYTES } from './imagem.js';
export type { ImagemReduzida } from './imagem.js';

// O CAMPO DE ANEXO, que serve as duas telas de mensagem: a Ajuda dos produtos e a resposta
// do Super Admin. Ele NAO envia: entrega o base64 ja reduzido, e quem envia e quem sabe
// para onde, porque os dois lados atravessam autorizacoes diferentes.
export { CampoAnexo } from './components/CampoAnexo.js';
export type { CampoAnexoProps } from './components/CampoAnexo.js';

// O RASTRO DO CURSOR, porte declarado do efeito congelado do site institucional. Ele mora
// aqui, e nao em `@complexity/auth`, porque e peca VISUAL e nao de identidade: qualquer tela
// da plataforma pode usa-lo, e a de entrada e apenas a primeira.
export { RastroDoCursor } from './components/RastroDoCursor.js';

// O HOOK DE IDIOMA VIVO. Sem ele, trocar de idioma grava o cookie e NAO redesenha a tela: o
// texto so muda no reload seguinte, sem erro nenhum para denunciar.
export { useIdiomaVivo } from './hooks/useIdiomaVivo.js';

// O DICIONARIO DAS PECAS REGISTRA-SE SOZINHO, na carga do modulo, pelo mesmo motivo do
// chassi de entrada: registrar e responsabilidade de quem TEM as frases. Deixado a cargo do
// app, o produto que nascesse amanha teria `(obrigatório)` em portugues no modo ingles, e so
// quem usa leitor de tela ouviria o defeito.
import { registrarDicionario } from '@complexity/i18n';
import { EN_UI } from './i18n/en.js';

registrarDicionario('en', EN_UI);

export { EN_UI } from './i18n/en.js';
